import { updateUrlParameter } from "./Utils/Utils";

export function redirectToLoginStap1(): void {
    let popupUrl: string = updateUrlParameter(window.location.href, "safariWorkaround", "stap1");
    window.open(popupUrl, "SafariWorkaround", "height=100,width=100,left=0,top=0,menubar=no,resizable=no,scrollbars=no,status=no,titlebar=no,toolbar=no,location=no");

    let div: HTMLDivElement = document.createElement("div");
    div.style.textAlign = "center";
    div.style.margin = "40px";
    div.style.fontSize = "1em";

    let span: HTMLSpanElement = document.createElement("span");
    span.innerText = "De cookies worden gecontroleerd en de pagina wordt herladen...";
    div.appendChild(span);

    document.body.innerHTML = div.outerHTML;
};